module.exports = __webpack_public_path__ + "static/media/bg-flora-palm.4cb4776b.svg";